//TODO: this is a hack because of issue #16 : tokens don't have the same order
import { Token } from '../token/token'
import { Address } from '../../utils/types'

export function reorderTokens<T extends Token>(
  tokens: T[],
  addresses: Address[]
): T[] {
  const result: T[] = []
  for (const address of addresses) {
    const next = tokens.find(t => t.address === address)
    if (!next) {
      console.error('Impossible to find token with address', address)
    } else {
      result.push(next)
    }
  }
  return result
}
